import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styles from './index.module.scss';
import IconL from './iconL';
import IconR from './iconR';

const Banner = () => {
    const { t } = useLang('Delta3AirSeries.Banner');
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        className: styles.comp,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1763512044760/kv1-pc.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1763512044618/kv1-m.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1763512044618/kv1-m.jpg',
        label: t.rich('label', {
            text1: (str: string) => {
                return (
                    <span className="mark">
                        {IconL()}
                        {str}
                        {IconR()}
                    </span>
                );
            },
            sub: (str: string) => {
                return (
                    <span className="sub">
                        {str}
                    </span>
                );
            },
        }),
        labelColor: '#ffffff',
        title: t('title'),
        desc: t('desc'),
        rBtnIsYouToBe: true,
        lHref: 'https://ph.ecoflow.com/products/delta-3-air-series-portable-power-station',
        lChildren: t('btnL'),
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'buy',
            position: 'https://ph.ecoflow.com/products/delta-3-air-series-portable-power-station',
            button_name: t('btnL'),
            __btn_id1: 'BannerA .__btn_l',
            __btn_id2: 'bannerBtnL',
            __btn_type: 'common',
        },
        rDataLayer: {
            event: 'uaEvent',
            event_name: 'video',
            title_name: t('btnR'),
            position: 'https://www.youtube.com/embed/Feq0gR5F6Xc?si=WecVIXeQpsX4sPwe',
            __btn_id1: 'BannerA .__btn_r',
            __btn_id2: 'bannerBtnR',
            __btn_type: 'common',
        },

        theme: 'white',
        rType: 'outlined',
        rHref: 'https://www.youtube.com/embed/Feq0gR5F6Xc?si=WecVIXeQpsX4sPwe',
        rChildren: t('btnR'),
    };
    return (
        <section className={`${styles.Banner} GtmModuleData-section`} data-section-id="bannerA">
            <EcoBanner {...dataA} />
        </section>
    );
};

export default Banner;
